export const RESET_STATE = "RESET_STATE";
export const SET_POST_TYPE = "SET_POST_TYPE";
export const SET_IS_FETCHING = "SET_IS_FETCHING";
export const SET_FOCUSED_DATE = "SET_FOCUSED_DATE";
export const SET_DATE_TO_BE_FOCUSED = "SET_DATE_TO_BE_FOCUSED";
export const UPDATE_TIMELINE_ACTIVITIES = "UPDATE_TIMELINE_ACTIVITIES";
export const SET_DATE_RANGE_TO_BE_FETCHED = "SET_DATE_RANGE_TO_BE_FETCHED";
